import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { EventService } from '../../service/event.service';
import { formatDate, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { EventDTO } from '../../../../models/EventDTO';
import { TranslateService } from '@ngx-translate/core';
import { GlassConfirmService } from '../../../../shared/components/glass-confirm/glass-confirm.service';
import heic2any from 'heic2any';

registerLocaleData(localeFr, 'fr-FR');


@Component({
  selector: 'app-gestion-evenement',
  templateUrl: './gestion-evenement.component.html',
  styleUrl: './gestion-evenement.component.css',
})
export class GestionEvenementComponent implements OnInit {
  currentDate = new Date();
  currentMonth = '';
  currentYear = 0;
  selectedDate = new Date();
  daysInMonth: any[] = [];
  weekDays = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
  selectedDayEvents: any[] = [];
  isAddEventVisible = false;
  inputDate = '';
  selectedDayName: string = ''; // Nom du jour sélectionné
  selectedFullDate: string = ''; // Date complète formatée en français
  selectedDay: any = null; // Jour sélectionné
  private events: { [key: string]: any[] } = {}; // Événements par date
imagePreviewUrl: string | ArrayBuffer | null = null;
  selectedEvent: EventDTO | null = null; // Holds the selected event details
  isPopupVisible = false; // Variable pour le contrôle de la popup
  showAllEvents = false; // Toggle all events modal
  isEditMode = false; // Indique si le formulaire est en mode modification
  public userIdKey = parseInt(localStorage.getItem('userId') as string, 10);
  public userRole = localStorage.getItem('_sid'); // Récupérer le rôle de l'utilisateur

  newEvent = {
    name: '',
    description: '',
    dateEvent: '',
  };
  constructor(
    private notification: NzNotificationService,
    private eventService : EventService, 
    private translate: TranslateService,
    private glassConfirm: GlassConfirmService
  ) { }
  ngOnInit() {
    this.updateCalendar();
    this.updateSelectedDateInfo();
    this.loadEvents();
  }

  isDirecteur(): boolean {
    const userRole = localStorage.getItem('_sid');
    return userRole === 'Directeur';
  }
  isParent(): boolean {
    const userRole = localStorage.getItem('_sid');
    return userRole === 'Parent';
  }
  isFormateur(): boolean {
    const userRole = localStorage.getItem('_sid');
    return userRole === 'Educateur';
  }
  loadEvents(): void {
    const etablissementId = localStorage.getItem('etablissementId');
  
    if (!etablissementId) {
      console.warn("etablissementId non trouvé dans le localStorage.");
      return;
    }
  
    const today = new Date();
  
    this.eventService.getEvenementsAfterToday(+etablissementId).subscribe({
      next: (events) => {
        this.events = events
          .filter((event: any) => new Date(event.dateEvent) >= today)
          .reduce((acc: any, event: any) => {
            const dateKey = formatDate(event.dateEvent, 'yyyy-MM-dd', 'fr-FR');
            if (!acc[dateKey]) acc[dateKey] = [];
            acc[dateKey].push(event);
            return acc;
          }, {});
        this.updateCalendar(); // Si tu as une méthode pour rafraîchir l'affichage
      },
      error: (err) => {
        console.error('Erreur lors du chargement des événements:', err);
      },
    });
  }
  
  
  canDeleteEvent(): boolean {
    // Si l'utilisateur est Directeur, il peut tout supprimer
    if (this.userRole === 'Directeur') {
      return true;
    }
  
    // Si l'utilisateur est un Éducateur, il ne peut supprimer que ses propres événements
    return this.selectedEvent?.userId === this.userIdKey;
  }
  updateCalendar() {
    const firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
    const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
  
    this.currentMonth = firstDay.toLocaleString('fr-FR', { month: 'long' });
    this.currentYear = firstDay.getFullYear();
  
    const daysInCurrentMonth = lastDay.getDate();
    const firstDayIndex = firstDay.getDay(); // Jour de la semaine du premier jour du mois (0 pour Dimanche, 1 pour Lundi, etc.)
  
    const days = [];
  
    // Ajouter des cellules vides pour les jours avant le 1er du mois
    for (let i = 0; i < firstDayIndex; i++) {
      days.push({
        date: null, // Cellule vide pour les jours avant le 1er du mois
        isPrevMonth: false,
        isNextMonth: false,
        isToday: false,
        hasEvent: false,
      });
    }
  
    // Ajouter les jours du mois courant
    for (let i = 1; i <= daysInCurrentMonth; i++) {
      const isToday = this.isSameDay(new Date(), new Date(this.currentYear, this.currentDate.getMonth(), i));
      const formattedDate = formatDate(new Date(this.currentYear, this.currentDate.getMonth(), i), 'yyyy-MM-dd', 'fr-FR');
  
      days.push({
        date: i,
        isPrevMonth: false,
        isNextMonth: false,
        isToday,
        hasEvent: !!this.events[formattedDate],
      });
    }
  
    // Ajouter des cellules vides pour les jours après le dernier du mois
    const totalCells = 42; // 6 semaines × 7 jours
    while (days.length < totalCells) {
      days.push({
        date: null, // Cellule vide pour les jours après le dernier du mois
        isPrevMonth: false,
        isNextMonth: false,
        isToday: false,
        hasEvent: false,
      });
    }
  
    this.daysInMonth = days;
  }
  updateSelectedDateInfo(): void {
    const options: Intl.DateTimeFormatOptions = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    this.selectedDayName = this.selectedDate.toLocaleDateString('fr-FR', { weekday: 'long' });
    this.selectedFullDate = this.selectedDate.toLocaleDateString('fr-FR', options);
  }
  isSameDay(d1: Date, d2: Date) {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
  }
  goToPreviousMonth() {
    this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
    this.updateCalendar();
  }
  goToNextMonth() {
    this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
    this.updateCalendar();
  }
  goToToday() {
    this.currentDate = new Date();
    this.updateCalendar();
  }
  goToDate() {
    const [month, year] = this.inputDate.split('/').map((v) => +v);
    if (!isNaN(month) && !isNaN(year)) {
      this.currentDate = new Date(year, month - 1, 1);
      this.updateCalendar();
    }
  }
  selectDay(day: any) {
    const today = new Date();
    const selectedDate = new Date(this.currentYear, this.currentDate.getMonth(), day.date);
  
    if (selectedDate < today) {
      this.notification.create('warning', 
        this.translate.instant('EVENTS.NOTIFICATIONS.INVALID_DATE_TITLE'),
        this.translate.instant('EVENTS.NOTIFICATIONS.INVALID_DATE_MSG'),
        {
          nzPlacement: 'bottomLeft',
          nzDuration: 3000,
        });
      return;
    }
  
    this.selectedDate = selectedDate;
    this.selectedDay = day;
    this.updateSelectedDateInfo();
    this.isAddEventVisible = false;
    this.closePopup();
  
    const selectedDateKey = formatDate(this.selectedDate, 'yyyy-MM-dd', 'fr-FR');
    this.selectedDayEvents = this.events[selectedDateKey] || [];
  
    if (this.selectedDayEvents.length > 0) {
      this.openEventPopup(this.selectedDayEvents[0]);
    } else {
      this.isAddEventVisible = true;
    }
  }
  

  toggleAddEvent() {
    this.isAddEventVisible = !this.isAddEventVisible;
    this.isEditMode = false; // Mode par défaut : ajout
  }

  toggleAllEvents() {
    this.showAllEvents = !this.showAllEvents;
  }

  get allEventsList(): any[] {
    const all: any[] = [];
    for (const dateKey of Object.keys(this.events)) {
      for (const event of this.events[dateKey]) {
        all.push({ ...event, _dateKey: dateKey });
      }
    }
    all.sort((a, b) => (a._dateKey || '').localeCompare(b._dateKey || ''));
    return all;
  }

  get allEventsGrouped(): { dateFormatted: string; events: any[] }[] {
    const map = new Map<string, any[]>();
    for (const event of this.allEventsList) {
      const key = event._dateKey || '';
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(event);
    }
    const result: { dateFormatted: string; events: any[] }[] = [];
    for (const [dateKey, events] of map) {
      const d = new Date(dateKey + 'T00:00:00');
      const formatted = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      result.push({ dateFormatted: formatted, events });
    }
    return result;
  }

  openEventFromAll(event: any) {
    this.showAllEvents = false;
    if (event._dateKey) {
      const parts = event._dateKey.split('-');
      const day = { date: parseInt(parts[2]), isPrevMonth: false, isNextMonth: false, isToday: false, hasEvent: true };
      this.selectDay(day);
    }
    setTimeout(() => this.openEventPopup(event), 200);
  }

  openEditEvent(event: any) {
    this.isAddEventVisible = true;
    this.isEditMode = true; // Activer le mode modification
    this.newEvent = { 
      name: event.titre, 
      description: event.description, 
      dateEvent: event.dateEvent, 

    };
  }
  resetSelectedEvent() {
    this.selectedEvent = null;
}
checkBeforeSaveEvent() {
  if (!this.newEvent.name) {
    this.notification.create('warning', 'Avertissement', 'Le nom de l’événement est manquant.', { nzPlacement: 'bottomLeft', nzDuration: 3000 });
    return;
  }
  
  const selectedDate = new Date(this.selectedDate);
  const today = new Date();
  today.setHours(0,0,0,0);
  
  if (selectedDate < today) {
    this.notification.create('warning', 'Avertissement', 'Vous ne pouvez pas ajouter d’événement avant la date d’aujourd’hui.', { nzPlacement: 'bottomLeft', nzDuration: 3000 });
    return;
  }

  this.glassConfirm.confirm({
    icon: 'fas fa-check-circle',
    iconColor: 'primary',
    title: this.translate.instant('EVENTS.MODAL_CONFIRM_SAVE.TITLE'),
    message: this.translate.instant('EVENTS.MODAL_CONFIRM_SAVE.MESSAGE') + ' ' + this.newEvent.name + ' ?',
    confirmText: this.translate.instant('EVENTS.MODAL_CONFIRM_SAVE.YES_BTN'),
    cancelText: this.translate.instant('EVENTS.MODAL_CONFIRM_SAVE.NO_BTN'),
    confirmColor: 'primary'
  }).then(confirmed => {
    if (confirmed) {
      this.confirmSaveEvent();
    }
  });
}

confirmSaveEvent() {
  if (this.isEditMode) {
    this.updateEvenement();
  } else {
    this.executeAddEvent();
  }
}

executeAddEvent() {
  const selectedDate = new Date(this.selectedDate);
  const { name, description } = this.newEvent;
  const formattedDate = formatDate(selectedDate, 'yyyy-MM-dd', 'fr-FR');

  this.eventService.createEvenement(
    name,
    description,
    this.userIdKey,
    formattedDate,
    this.selectedImage ?? undefined
  ).subscribe({
    next: (event) => {
      console.log('Événement créé:', event);

      // Ajouter l'événement à la liste locale
      if (!this.events[formattedDate]) {
        this.events[formattedDate] = [];
      }
      this.events[formattedDate].push(event);

      // Ajouter un indicateur visuel au jour correspondant
      const dayIndex = this.daysInMonth.findIndex(day =>
        !day.isPrevMonth &&
        !day.isNextMonth &&
        this.isSameDay(
          this.selectedDate,
          new Date(this.currentYear, this.currentDate.getMonth(), day.date)
        )
      );
      if (dayIndex !== -1) {
        this.daysInMonth[dayIndex].hasEvent = true;
      }

      // Réinitialiser le formulaire
      this.resetForm();

      // Afficher une notification de succès
      this.notification.create(
        'success',
        this.translate.instant('EVENTS.NOTIFICATIONS.ADD_SUCCESS_TITLE'),
        this.translate.instant('EVENTS.NOTIFICATIONS.ADD_SUCCESS_MSG', { title: event.titre }),
        {
          nzPlacement: 'bottomLeft',
          nzDuration: 3000,
        }
      );
    },
    error: (err) => {
      console.error('Erreur lors de la création de l’événement:', err);
    },
  });
  
  this.toggleAddEvent();
}


saveEditedEvent() {
  // Logique pour sauvegarder les modifications de l'événement
  console.log('Modification de l\'événement', this.newEvent);
  this.isAddEventVisible = false;
}
onDeleteEvent(): void {
  if (!this.selectedEvent?.id) {
    console.error('Aucun événement sélectionné pour suppression.');
    this.notification.create('error', 
      this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_TITLE'), 
      this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_NO_SELECTION'), {
      nzPlacement: 'bottomLeft',
      nzDuration: 3000,
    });
    return;
  }

  // Vérifier si l'utilisateur connecté est bien le créateur
  if (this.selectedEvent.userId !== this.userIdKey) {
    this.notification.create(
      'error',
      this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_DENIED_TITLE'),
      this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_DENIED_MSG'),
      {
        nzPlacement: 'bottomLeft',
        nzDuration: 3000,
      }
    );
    return;
  }

  this.eventService.deleteEvenement(this.selectedEvent.id).subscribe({
    next: () => {
      console.log('Événement supprimé avec succès');

      // Supprimer l'événement de la liste affichée
      this.selectedDayEvents = this.selectedDayEvents.filter(event => event.id !== this.selectedEvent?.id);

      this.notification.create('success', 
        this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_SUCCESS_TITLE'), 
        this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_SUCCESS_MSG', { title: this.selectedEvent?.titre }), {
        nzPlacement: 'bottomLeft',
        nzDuration: 3000,
      });

      this.closePopup();
    },
    error: (error) => {
      console.error('Erreur lors de la suppression de l’événement:', error);
      this.notification.create('error', 
        this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_TITLE'), 
        this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_SERVER'), {
        nzPlacement: 'bottomLeft',
        nzDuration: 3000,
      });
    },
  });
}



openEventPopup(event: any): void {
  console.log('ID de l’événement:', event.id); // Vérifiez l’ID ici
  if (event.id) {
    this.fetchEventDetails(event.id); // Appeler la méthode pour obtenir les détails de l'événement
    this.isPopupVisible = true; // Afficher la popup
  }
}

closePopup(): void {
  this.isPopupVisible = false; // Désactive la modal
  this.selectedEvent = null; // Réinitialise l'événement sélectionné

}

  resetForm() {
    this.newEvent = { name: '', description: '', dateEvent: '' };
    this.isAddEventVisible = false;
    this.selectedImage = null;
    this.imagePreviewUrl = null;
  }
  fetchEventDetails(eventId: number): void {
    this.eventService.getEvenementById(eventId).subscribe({
      next: (event) => {
        console.log('Détails de l’événement récupérés:', event);
  
        this.selectedEvent = {
          ...event,
          userNom: event.userNom ?? 'Inconnu',
          userPrenom: event.userPrenom ?? '',
          userPhotoUrl: event.userPhotoUrl ?? ''
        };
      },
      error: (err) => {
        console.error('Erreur lors de la récupération des détails de l’événement:', err);
      },
    });
  }
  
  
  selectedImage: File | null = null;
onImageSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];

    // Vérifier si c’est un fichier HEIC/HEIF
    const isHeic = file.type === 'image/heic' || file.type === 'image/heif' ||
                   file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif');

    if (isHeic) {
      // Conversion HEIC → JPEG avec heic2any
      heic2any({ blob: file, toType: "image/jpeg", quality: 0.8 })
        .then((converted: Blob | Blob[]) => {
          // Si c'est un tableau, prendre le premier Blob
          const convertedBlob = Array.isArray(converted) ? converted[0] : converted;

          // Créer un fichier à partir du blob converti
          const jpegFile = new File(
            [convertedBlob],
            file.name.replace(/\.(heic|heif)$/i, '.jpg'),
            { type: 'image/jpeg' }
          );
          this.selectedImage = jpegFile;

          // Afficher l'aperçu
          const reader = new FileReader();
          reader.onload = () => this.imagePreviewUrl = reader.result;
          reader.readAsDataURL(jpegFile);
        })
        .catch((error) => {
          console.error('Erreur conversion HEIC:', error);
          this.selectedImage = null;
          this.imagePreviewUrl = null;
        });
    } else if (file.type.startsWith('image/')) {
      // Pas besoin de conversion, c’est un autre format d’image
      this.selectedImage = file;
      const reader = new FileReader();
      reader.onload = () => this.imagePreviewUrl = reader.result;
      reader.readAsDataURL(file);
    } else {
      // Pas un fichier image supporté
      this.selectedImage = null;
      this.imagePreviewUrl = null;
      console.warn('Fichier sélectionné non supporté');
    }
  }
}

  updateEvenement() {
    if (this.selectedEvent && this.newEvent.name && this.newEvent.dateEvent) { 
      const { id, description } = this.selectedEvent; // Removed dateEvent
  
      // Formater la date au format yyyy-MM-dd
      const formattedDate = formatDate(new Date(this.newEvent.dateEvent), 'yyyy-MM-dd', 'fr-FR');
  
      this.eventService.updateEvenement(
        id!,
        this.newEvent.name, // Use 'name' instead of 'titre'
        description,
        formattedDate,
        this.selectedImage ?? undefined
      ).subscribe({
        next: (updatedEvent) => {
          console.log('Événement mis à jour avec succès', updatedEvent);
  
          // Mettre à jour les événements dans la liste locale
          const selectedDateKey = this.selectedDate.toISOString().split('T')[0];
          this.events[selectedDateKey] = this.events[selectedDateKey].map(event =>
            event.id === updatedEvent.id ? updatedEvent : event
          );
  
          // Mettre à jour les jours du calendrier
          const dayIndex = this.daysInMonth.findIndex(day =>
            !day.isPrevMonth &&
            !day.isNextMonth &&
            this.isSameDay(
              this.selectedDate,
              new Date(this.currentYear, this.currentDate.getMonth(), day.date)
            )
          );
          if (dayIndex !== -1) {
            this.daysInMonth[dayIndex].hasEvent = true;
          }
  
          // Afficher une notification de succès
          this.notification.create(
            'success',
            this.translate.instant('EVENTS.NOTIFICATIONS.UPDATE_SUCCESS_TITLE'),
            this.translate.instant('EVENTS.NOTIFICATIONS.UPDATE_SUCCESS_MSG', { title: updatedEvent.titre }), // Use 'name' here
            {
              nzPlacement: 'bottomLeft',
              nzDuration: 3000,
            }
          );
  
          this.closePopup(); // Fermer la popup
        },
        error: (err) => {
          console.error('Erreur lors de la mise à jour de l’événement:', err);
  
          // Afficher une notification d'erreur
          this.notification.create(
            'error',
            this.translate.instant('EVENTS.NOTIFICATIONS.UPDATE_ERROR_TITLE'),
            this.translate.instant('EVENTS.NOTIFICATIONS.UPDATE_ERROR_MSG'),
            {
              nzPlacement: 'bottomLeft',
              nzDuration: 3000,
            }
          );
        },
      });
    } else {
      console.warn('Données manquantes pour la mise à jour de l’événement.');
    }
  }
  
  
  confirmDeleteEvent(): void {
    if (!this.selectedEvent?.id) {
      console.error('No event ID found for deletion.');
      this.notification.create(
        'error',
        this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_TITLE'),
        this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_NO_SELECTION'),
        { nzPlacement: 'bottomLeft', nzDuration: 3000 }
      );
      return;
    }

    this.glassConfirm.confirm({
      icon: 'fas fa-trash',
      iconColor: 'danger',
      title: this.translate.instant('EVENTS.MODAL_CONFIRM_DELETE.TITLE'),
      message: this.translate.instant('EVENTS.MODAL_CONFIRM_DELETE.MESSAGE') + ' ' + this.selectedEvent?.titre + ' ?',
      confirmText: this.translate.instant('EVENTS.MODAL_CONFIRM_DELETE.YES_BTN'),
      cancelText: this.translate.instant('EVENTS.MODAL_CONFIRM_DELETE.NO_BTN'),
      confirmColor: 'danger'
    }).then(confirmed => {
      if (confirmed && this.selectedEvent?.id) {
        this.eventService.deleteEvenement(this.selectedEvent.id).subscribe({
          next: (response) => {
            console.log('Event deleted successfully:', response);
            this.selectedDayEvents = this.selectedDayEvents.filter(event => event.id !== this.selectedEvent?.id);
            this.notification.create(
              'success',
              this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_SUCCESS_TITLE'),
              this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_SUCCESS_MSG', { title: this.selectedEvent?.titre }),
              { nzPlacement: 'bottomLeft', nzDuration: 3000 }
            );
            window.location.reload();
          },
          error: (error) => {
            console.error('Error deleting event:', error);
            this.notification.create(
              'error',
              this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_SERVER'),
              this.translate.instant('EVENTS.NOTIFICATIONS.DELETE_ERROR_SERVER'),
              { nzPlacement: 'bottomLeft', nzDuration: 3000 }
            );
          },
        });
      }
    });
  }
  
  
}